/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionnaireConfigRecommendedStrategyFund } from './QuestionnaireConfigRecommendedStrategyFund';
import {
    QuestionnaireConfigRecommendedStrategyFundFromJSON,
    QuestionnaireConfigRecommendedStrategyFundFromJSONTyped,
    QuestionnaireConfigRecommendedStrategyFundToJSON,
    QuestionnaireConfigRecommendedStrategyFundToJSONTyped,
} from './QuestionnaireConfigRecommendedStrategyFund';

/**
 * 
 * @export
 * @interface QuestionnaireConfigRecommendedStrategy
 */
export interface QuestionnaireConfigRecommendedStrategy {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigRecommendedStrategy
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigRecommendedStrategy
     */
    name: string;
    /**
     * 
     * @type {Array<QuestionnaireConfigRecommendedStrategyFund>}
     * @memberof QuestionnaireConfigRecommendedStrategy
     */
    funds: Array<QuestionnaireConfigRecommendedStrategyFund>;
}

/**
 * Check if a given object implements the QuestionnaireConfigRecommendedStrategy interface.
 */
export function instanceOfQuestionnaireConfigRecommendedStrategy(value: object): value is QuestionnaireConfigRecommendedStrategy {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('funds' in value) || value['funds'] === undefined) return false;
    return true;
}

export function QuestionnaireConfigRecommendedStrategyFromJSON(json: any): QuestionnaireConfigRecommendedStrategy {
    return QuestionnaireConfigRecommendedStrategyFromJSONTyped(json, false);
}

export function QuestionnaireConfigRecommendedStrategyFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireConfigRecommendedStrategy {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'funds': ((json['funds'] as Array<any>).map(QuestionnaireConfigRecommendedStrategyFundFromJSON)),
    };
}

export function QuestionnaireConfigRecommendedStrategyToJSON(json: any): QuestionnaireConfigRecommendedStrategy {
    return QuestionnaireConfigRecommendedStrategyToJSONTyped(json, false);
}

export function QuestionnaireConfigRecommendedStrategyToJSONTyped(value?: QuestionnaireConfigRecommendedStrategy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'funds': ((value['funds'] as Array<any>).map(QuestionnaireConfigRecommendedStrategyFundToJSON)),
    };
}

